const hasFeature = (flags, permission) => !permission || flags.includes(permission);

export default hasFeature;
